
export function parseEventKey(eventKey: string) {
    if (!eventKey) {
        return {
            raw: eventKey,
            parts: [],
            category: '',
            scopes: [],
            event: '',
            label: ''
        };
    }

    const parts: string[] = eventKey.split('.');
    let cleanParts: string[] = [];
    let i: number;

    for (i = 0; i < parts.length; i++) {
        let part: string = parts[i];
        if (part) {
            part = String(part).replaceAll(/^\s+|\s+$/g, '');
            if (part) {
                cleanParts.push(part);
            }
        }
    }

    const category: string = cleanParts.length > 0 ? cleanParts[0] : '';
    const event: string = cleanParts.length > 1 ? cleanParts[cleanParts.length - 1] : category;
    let scopes: string[] = [];

    if (cleanParts.length > 2) {
        for (i = 1; i < cleanParts.length - 1; i++) {
            scopes.push(cleanParts[i]);
        }
    }

    return {
        raw: eventKey,
        parts: cleanParts,
        category: category,
        scopes: scopes,
        event: event,
        label: buildEventLabel(category, scopes, event)
    };
}

export function humaniseToken(token: string) {
    if (!token) {
        return '';
    }

    let value = String(token);

    value = value.replaceAll(/[_-]/g, ' ');
    value = value.replaceAll(/([a-z])([A-Z])/g, '$1 $2');
    value = value.replaceAll(/\s+/g, ' ');
    value = value.replaceAll(/^\s+|\s+$/g, '');

    if (!value) {
        return '';
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
}

function buildEventLabel(category: string, scopes: Array<string>, event: string) {
    let parts = [];
    let i;

    if (category) {
        parts.push(humaniseToken(category));
    }

    if (scopes?.length) {
        for (i = 0; i < scopes.length; i++) {
            parts.push(humaniseToken(scopes[i]));
        }
    }

    if (event) {
        parts.push(humaniseToken(event));
    }

    return parts.join(' ');
}

export function capitalise(text: string) {
    if (!text) {
        return '';
    }

    text = String(text);

    return text.charAt(0).toUpperCase() + text.slice(1);
}